import { render, staticRenderFns } from "./TableTotalItem.vue?vue&type=template&id=2ee74d94&"
import script from "./TableTotalItem.vue?vue&type=script&lang=js&"
export * from "./TableTotalItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports